import Header from './components/Header';
import Index from './containers/Index.js';

function App() {
  return (
    <div className="App">
        <Header />
        <Index />
    </div>
  );
}

export default App;
